import { configureStore } from '@reduxjs/toolkit';
import reducer from './modules/reducer';

export default configureStore({
  reducer,
});
